<template>
  <div v-if="isOpen" class="published-list-overlay" @mousedown="handleOverlayMouseDown" @mouseup="handleOverlayMouseUp">
    <div class="published-list-content" @mousedown="handleContentMouseDown">
      <h3 class="published-list-title">公開中のブクマす一覧（{{ pages.length }}件）</h3>

      <div class="published-list-body">
        <div v-if="pages.length === 0" class="no-pages">
          公開中のブクマすはありません。
        </div>

        <div v-for="(page, index) in pages" :key="page.cloudId" class="page-entry">
          <div class="page-header">
            <span class="page-name">{{ page.pageName || ('ページ ' + (index + 1)) }}</span>
          </div>
          <div class="url-row">
            <div class="url-display">{{ page.publishUrl }}</div>
            <button class="action-button copy-button" @click="copyUrl(page.publishUrl, index)">
              {{ copiedIndex === index ? 'コピー完了' : 'コピー' }}
            </button>
            <button class="action-button delete-button" @click="confirmUnpublish(page)">
              削除
            </button>
          </div>
        </div>
      </div>

      <div class="published-list-footer">
        <button class="close-button" @click="close">閉じる</button>
      </div>
    </div>
    <!-- 確認ダイアログ（window.confirm代替） -->
    <v-dialog v-model="confirmDialog.isOpen" max-width="320" persistent>
      <v-card>
        <v-card-title class="text-body-1 font-weight-bold pt-4 px-4">{{ confirmDialog.title }}</v-card-title>
        <v-card-text class="px-4 pb-2" style="white-space: pre-line;">{{ confirmDialog.message }}</v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="onConfirmCancel">キャンセル</v-btn>
          <v-btn color="warning" variant="elevated" @click="onConfirmOk">{{ confirmDialog.okLabel }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'PublishedPagesListModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    publishedPagesList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'unpublish'],
  data() {
    return {
      copiedIndex: -1,
      mouseDownOnOverlay: false,
      confirmDialog: {
        isOpen: false,
        title: '確認',
        message: '',
        okLabel: 'OK',
        resolve: null
      }
    };
  },
  computed: {
    pages() {
      return this.publishedPagesList || [];
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.copiedIndex = -1;
      }
    }
  },
  methods: {
    copyUrl(url, index) {
      if (!url) return;
      try {
        navigator.clipboard.writeText(url).then(() => {
          this.copiedIndex = index;
          setTimeout(() => { this.copiedIndex = -1; }, 2000);
        });
      } catch (error) {
        console.error('クリップボードへのコピーに失敗しました', error);
      }
    },
    showConfirm(message, { title = '確認', okLabel = 'OK' } = {}) {
      return new Promise((resolve) => {
        this.confirmDialog.title = title;
        this.confirmDialog.message = message;
        this.confirmDialog.okLabel = okLabel;
        this.confirmDialog.resolve = resolve;
        this.confirmDialog.isOpen = true;
      });
    },
    onConfirmOk() {
      this.confirmDialog.isOpen = false;
      if (this.confirmDialog.resolve) {
        this.confirmDialog.resolve(true);
        this.confirmDialog.resolve = null;
      }
    },
    onConfirmCancel() {
      this.confirmDialog.isOpen = false;
      if (this.confirmDialog.resolve) {
        this.confirmDialog.resolve(false);
        this.confirmDialog.resolve = null;
      }
    },

    async confirmUnpublish(page) {
      const name = page.pageName || 'このブクマす';
      const confirmed = await this.showConfirm(
        `「${name}」の公開を停止します。公開URLは無効になります。よろしいですか？`,
        { title: '非公開の確認', okLabel: '非公開にする' }
      );
      if (!confirmed) return;
      this.$emit('unpublish', page);
    },
    close() {
      this.$emit('close');
    },
    handleOverlayMouseDown(e) {
      this.mouseDownOnOverlay = e.target.classList.contains('published-list-overlay');
    },
    handleOverlayMouseUp(e) {
      if (this.mouseDownOnOverlay && e.target.classList.contains('published-list-overlay')) {
        this.close();
      }
      this.mouseDownOnOverlay = false;
    },
    handleContentMouseDown() {
      this.mouseDownOnOverlay = false;
    }
  }
};
</script>

<style scoped>
.published-list-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}
.published-list-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 540px;
  max-height: 80vh;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.published-list-title {
  color: #333;
  margin-top: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
  flex-shrink: 0;
}
.published-list-body {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}
.no-pages {
  text-align: center;
  color: #999;
  padding: 30px 0;
  font-size: 0.95rem;
}
.page-entry {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
}
.page-entry:last-child {
  margin-bottom: 0;
}
.page-header {
  margin-bottom: 8px;
}
.page-name {
  font-weight: 600;
  font-size: 0.92rem;
  color: #444;
}
.url-row {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}
.url-display {
  flex: 1;
  padding: 8px 10px;
  background-color: #f8f8f8;
  font-family: monospace;
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.action-button {
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.85rem;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.copy-button {
  background-color: #e9d0ca;
  color: #333;
  border-left: 1px solid #ddd;
}
.copy-button:hover {
  background-color: #e0c0b8;
}
.delete-button {
  background-color: #f5f5f5;
  color: #c62828;
  border-left: 1px solid #ddd;
}
.delete-button:hover {
  background-color: #ffebee;
}
.published-list-footer {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  flex-shrink: 0;
}
.close-button {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 50px;
  padding: 10px 30px;
  font-size: 0.95rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}
.close-button:hover {
  background-color: #d9b6ab;
}
@media (max-width: 600px) {
  .published-list-content {
    padding: 20px;
  }
  .action-button {
    padding: 8px 10px;
    font-size: 0.8rem;
  }
}
</style>
